const MAX_WAIT_FOR_INTEGRATION_LOAD = 10000;
const INTEGRATION_LOAD_CHECK_INTERVAL = 1000;
const LOAD_ORIGIN = 'RS_JS_SDK';
const FAILED_REQUEST_ERR_MSG_PREFIX = 'Request failed with status:';
const ERROR_MESSAGES_TO_BE_FILTERED = [FAILED_REQUEST_ERR_MSG_PREFIX];
const ERROR_REPORTING_SERVICE_GLOBAL_KEY_NAME = 'errorReporting';

export {
  MAX_WAIT_FOR_INTEGRATION_LOAD,
  INTEGRATION_LOAD_CHECK_INTERVAL,
  LOAD_ORIGIN,
  FAILED_REQUEST_ERR_MSG_PREFIX,
  ERROR_MESSAGES_TO_BE_FILTERED,
  ERROR_REPORTING_SERVICE_GLOBAL_KEY_NAME,
};
